import _ from "lodash";

// return a single page of countries sliced from the total collection of items
export function paginate(data, pageNumber, pageSize) {
  const startIndex = (pageNumber - 1) * pageSize;
  return _(data).slice(startIndex).take(pageSize).value();
}
